import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import AboutPage from './pages/AboutPage';
import WhoUsesPlayfairPage from './pages/WhoUsesPlayfairPage';
import PerksPage from './pages/PerksPage';
import BlogPage from './pages/BlogPage';
import GettingStartedPage from './pages/GettingStartedPage';
import FAQPage from './pages/FAQPage';
import { SignInPage } from './pages/StaticPages';
import { AuthProvider } from './context/AuthContext';
import RequireAuth from './components/RequireAuth';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/privacy" element={<Layout><PrivacyPolicyPage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/who-uses-playfair" element={<Layout><WhoUsesPlayfairPage /></Layout>} />
          <Route
            path="/perks"
            element={
              <Layout>
                <RequireAuth>
                  <PerksPage />
                </RequireAuth>
              </Layout>
            }
          />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          <Route path="/resources/blog" element={<Layout><BlogPage /></Layout>} />
          <Route path="/resources/getting-started" element={<Layout><GettingStartedPage /></Layout>} />
          <Route path="/resources/faq" element={<Layout><FAQPage /></Layout>} />
          <Route path="/sign-in" element={<Layout><SignInPage /></Layout>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
